import { FC, useEffect, useState } from "react"

import { Grid } from "@mui/material"
import { IGetStudentPossibleJobsInClass } from "api/reactQuery/queries/studentJobs.types"
import StudentSkeleton from "components/common/skeleton/studentProfile"

import JobsOfferAside from "./jobsOfferAside"
import JobsOfferSpecify from "./jobsOfferSpecify"
import { JOBS_PANEL_VIEW_BREAKPOINT } from "./JobsPanel.config"

const JobsPanel: FC<{
  jobsState: IGetStudentPossibleJobsInClass[]
  isLoading: boolean
}> = ({ jobsState, isLoading }) => {
  const [selectedJob, setSelectedJob] = useState<IGetStudentPossibleJobsInClass | null>(null)
  const [isExpanded, setIsExpanded] = useState(true)

  useEffect(() => {
    if (selectedJob && jobsState.length > 0) {
      const updatedJob = jobsState.find(job => job.id === selectedJob.id)
      if (updatedJob) {
        setSelectedJob(updatedJob)
      }
    }
  }, [jobsState, selectedJob])

  return (
    <Grid
      container
      spacing={{ mobile: 3, [JOBS_PANEL_VIEW_BREAKPOINT]: 2 }}
      flexWrap={{ mobile: "wrap-reverse", desktop: "nowrap" }}
      sx={(theme) => ({
        width: "100%",
        flexWrap: "wrap-reverse",
        [theme.breakpoints.up(JOBS_PANEL_VIEW_BREAKPOINT)]: {
          flexWrap: "nowrap",
        },
      })}
    >
      <Grid
        sx={(theme) => ({
          flexBasis: "100%",
          maxWidth: "100%",
          [theme.breakpoints.up(JOBS_PANEL_VIEW_BREAKPOINT)]: {
            flexBasis: "350px",
            maxWidth: "350px",
            flexShrink: 0,
          },
        })}
      >
        {isLoading ? (
          <StudentSkeleton height="300px" />
        ) : (
          <JobsOfferAside
            jobsState={jobsState}
            setSelectedJob={setSelectedJob}
            selectedJobId={selectedJob?.id || null}
            handleExpandToggle={() => {
              setIsExpanded((prev) => !prev)
            }}
          />
        )}
      </Grid>
      <Grid
        sx={(theme) => ({
          flexBasis: "100%",
          maxWidth: "100%",
          [theme.breakpoints.up(JOBS_PANEL_VIEW_BREAKPOINT)]: {
            flex: 1,
            minWidth: 0,
          },
        })}
      >
        {isLoading ? (
          <StudentSkeleton height="300px" />
        ) : (
          <JobsOfferSpecify 
            selectedJob={selectedJob} 
            isExpanded={isExpanded}
            setSelectedJob={setSelectedJob}
          />
        )}
      </Grid>
    </Grid>
  )
}

export default JobsPanel
